<template>
  <div class="WebsiteMenus">
    <h2 class="subtitle">Options du site internet</h2>
    <hr />
    <violet-bar>Menu et intitulés des pages</violet-bar>
    <div class="box">
      <div class="columns">
        <div class="column is-one-third">
          <h3 class="subitle">Page "Agence"</h3>
          <div class="field">
            <label for="" class="label">Titre de la page :</label>
            <input type="text" class="input" v-model="form.about.title" />
            <label for="" class="label">Apparence dans le menu :</label>
            <input type="text" class="input" v-model="form.about.menu" />
          </div>
        </div>
        <div class="column is-one-third">
          <h3 class="subitle">Page "Projets"</h3>
          <div class="field">
            <label for="" class="label">Titre de la page :</label>
            <input type="text" class="input" v-model="form.projects.title" />
            <label for="" class="label">Apparence dans le menu :</label>
            <input type="text" class="input" v-model="form.projects.menu" />
          </div>
        </div>
        <div class="column is-one-third">
          <h3 class="subitle">Page "Axes"</h3>
          <div class="field">
            <label for="" class="label">Titre de la page :</label>
            <input type="text" class="input" v-model="form.axes.title" />
            <label for="" class="label">Apparence dans le menu :</label>
            <input type="text" class="input" v-model="form.axes.menu" />
          </div>
        </div>
      </div>
    </div>
    <div class="buttons">
      <div class="button is-primary" @click="save">Enregistrer</div>
    </div>
  </div>
</template>

<script>
import VioletBar from "../Projects/VioletBar";
import { types } from "../../store/actions/misc";

const MenuForm = () => ({
  about: {
    menu: "",
    title: ""
  },
  projects: {
    menu: "",
    title: ""
  },
  axes: {
    menu: "",
    title: ""
  }
});
export default {
  name: "WebsiteMenus",
  components: { VioletBar },
  data() {
    return {
      form: MenuForm()
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async save() {
      this.form = await this.$store.dispatch(types.SET_MENUS, this.form);
    },
    async fetch() {
      try {
        this.form = await this.$store.dispatch(types.GET_MENUS);
      } catch (e) {
        this.form = MenuForm();
      }
    }
  }
};
</script>

<style scoped></style>
